export default "/images/vendor/flag-icon-css/flags/1x1/ge.svg?948ba6b5d63b61c2ae6e208d7ece002f";